import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Popover, Badge } from 'react-bootstrap';
import { isObject } from 'lodash';
import { useProductListingState } from '../RangePlanProductListingProvider';
import noImage from '../../../../assets/images/no-image.png';
import { checkArray, shortenandHoverString } from '../../../../Components/helper';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

export default function SupplierTable(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const { t } = useTranslation('common');
  const {
    rangePlanProvider: { productsNumber, productsList },
  } = useProductListingState();
  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };
  const expandAllProductSupplier = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };
  return (
    <div id="SupplierRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="SupplierRPTableContainer"
      >
        <table id="RPSupplierTable" className="table common-custom-table fixed-header mb-0">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_samples_supplier"
                    id="check_all_samples_supplier"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_samples_supplier" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAllProductSupplier()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_CODE')}</th>
              <th className="w-224px  first-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_NAME')}</th>
              <th className="w-250px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_COMP_TYPE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.BUILDING_NO')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_ADDRESS')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.TOWN_CITY')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.COUNTRY')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.POSTAL_CODE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_CURR')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.AGENT_FEE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_NOTE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.NEW_LEAD_TIME')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.SUPPLIER_TAG')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_CODE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_NAME')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_COMP_TYPE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.BUILDING_NO')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_ADDRESS')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.TOWN_CITY')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.COUNTRY')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.POSTAL_CODE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.PORT_OF_LADING')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.MOQ')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.MCQ')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.ENERGY_SOURCE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.ENERGY_INTENSITY')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.WORKER')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.POINT_OF_CONTACT')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_NOTES')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.LEAD_TIME')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.FACTORY_TAG')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.CONTACT_NAME')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.JOB_TITLE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.EMAIL')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.TELEPHONE')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_SUPLIER.DOCS')}</th>
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const productImage = ele?.image || noImage;
              const companies = ele?.initialData?.companies?.length > 0 && ele?.initialData?.companies[0];
              const factories = ele?.initialData?.factoryDetails;
              const noOfDocs = ele?.initialData?.supplierDocuments?.length > 0 ? ele?.initialData?.supplierDocuments?.length : 0;
              const factoryInfoData = ele?.initialData?.factoryDetails?.factoryInfo?.length > 0 && ele?.initialData?.factoryDetails?.factoryInfo[0];
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(ele?.number || '--', 30)}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name)?.join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(companies?.code || '--', 20)}
                        {ele?.suppliers?.length > 0 && (
                          <Link
                            target="_blank"
                            to={`/supplier/${ele?.initialData?._id}/users?supplierId=${ele?.initialData?._id}`}
                            className="px-3 ml-auto text-decoration-none"
                          >
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.suppliers?.length > 0 && <Badge className="range-badge badge badge-rp-counter">{ele?.suppliers?.length}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td className="first-fix-col">{companies?.supplierName}</td>
                    <td>{shortenandHoverString(companies?.supplierType?.map((item) => item?.name)?.join(', '), 50)}</td>
                    <td>{companies?.buildingNo}</td>
                    <td>{shortenandHoverString(companies?.streetAddress, 40)}</td>
                    <td>{shortenandHoverString(companies?.townCity, 40)}</td>
                    <td>{companies?.country?.label || companies?.country}</td>
                    <td>{companies?.zipCode}</td>
                    <td>{companies?.currency}</td>
                    <td>{companies?.agentFee}</td>
                    <td>{shortenandHoverString(companies?.note, 40)}</td>
                    <td>{companies?.newLeadTime}</td>
                    <td>{checkArray(companies?.tags) && companies?.tags?.join(', ')}</td>
                    <td>{factories?.factoryCode}</td>
                    <td>{factories?.factoryName}</td>
                    <td>
                      {checkArray(factoryInfoData?.productType) &&
                        shortenandHoverString(factoryInfoData?.productType?.map((item) => item?.name).join(', '), 50)}
                    </td>
                    <td>{factories?.buildingNo}</td>
                    <td>{shortenandHoverString(factories?.streetAddress, 40)}</td>
                    <td>{shortenandHoverString(factories?.townCity, 40)}</td>
                    <td>{factories?.country}</td>
                    <td>{factories?.zipCode}</td>
                    <td>{factories?.portOfLanding}</td>
                    <td>{factoryInfoData?.moq}</td>
                    <td>{factoryInfoData?.minimumColourQuantiy}</td>
                    <td>{factories?.energySource?.label}</td>
                    <td>{factories?.energyIntensity}</td>
                    <td>{factories?.noOfWorkers}</td>
                    <td>{factories?.internalPointContact?.label || factories?.internalPointContact}</td>
                    <td>{shortenandHoverString(factories?.factorynote, 40)}</td>
                    <td>{factories?.newLeadTime}</td>
                    <td>{factories?.tags?.join(', ')}</td>
                    <td>
                      {factories?.contactPersons?.map((item) => {
                        return (
                          <p className="mb-1" key={item?._id}>
                            {item?.name}
                          </p>
                        );
                      })}
                    </td>
                    <td>
                      {factories?.contactPersons?.map((item) => {
                        return (
                          <p className="mb-1" key={item?._id}>
                            {item?.jobTitle}
                          </p>
                        );
                      })}
                    </td>
                    <td>
                      {factories?.contactPersons?.map((item) => {
                        return (
                          <p className="mb-1" key={item?._id}>
                            {item?.email}
                          </p>
                        );
                      })}
                    </td>
                    <td>
                      {factories?.contactPersons?.map((item) => {
                        return (
                          <p className="mb-1" key={item?._id}>
                            {item?.phoneNo}
                          </p>
                        );
                      })}
                    </td>
                    <td>{noOfDocs}</td>
                  </tr>

                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      const companiesExpanded = expData?.companies?.length > 0 && expData?.companies[0];
                      const factoryExpanded = expData?.factoryDetails;
                      const noOfDocsExpad = expData?.supplierDocuments?.length > 0 ? expData?.supplierDocuments?.length : 0;
                      const factoryExpandedInfoData = expData?.factoryDetails?.factoryInfo?.length > 0 && expData?.factoryDetails?.factoryInfo[0];
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>
                            <div className="d-flex align-items-center">
                              {shortenandHoverString(companiesExpanded?.code || '--', 20)}
                              {ele?.suppliers?.length > 0 && (
                                <Link
                                  target="_blank"
                                  to={`/supplier/${expData?._id}/users?supplierId=${expData?._id}`}
                                  className="px-3 ml-auto text-decoration-none"
                                >
                                  <span className="icon-redirect f-20" />
                                </Link>
                              )}
                              <div style={{ width: 20 }} />
                            </div>
                          </td>
                          <td className="first-fix-col">{companiesExpanded?.supplierName}</td>
                          <td>{shortenandHoverString(companiesExpanded?.supplierType?.map((item) => item?.name)?.join(', '), 50)}</td>
                          <td>{companiesExpanded?.buildingNo}</td>
                          <td>{shortenandHoverString(companiesExpanded?.streetAddress, 40)}</td>
                          <td>{shortenandHoverString(companiesExpanded?.townCity, 40)}</td>
                          <td>{companiesExpanded?.country?.label || companiesExpanded?.country}</td>
                          <td>{companiesExpanded?.zipCode}</td>
                          <td>{companiesExpanded?.currency}</td>
                          <td>{companiesExpanded?.agentFee}</td>
                          <td>{shortenandHoverString(companiesExpanded?.note, 40)}</td>
                          <td>{companiesExpanded?.newLeadTime}</td>
                          <td>{checkArray(companiesExpanded?.tags) && companiesExpanded?.tags?.join(', ')}</td>
                          <td>{factoryExpanded?.factoryCode}</td>
                          <td>{factoryExpanded?.factoryName}</td>
                          <td>
                            {checkArray(factoryExpandedInfoData?.productType) &&
                              shortenandHoverString(factoryExpandedInfoData?.productType?.map((item) => item?.name).join(', '), 50)}
                          </td>
                          <td>{factoryExpanded?.buildingNo}</td>
                          <td>{shortenandHoverString(factoryExpanded?.streetAddress, 40)}</td>
                          <td>{shortenandHoverString(factoryExpanded?.townCity, 40)}</td>
                          <td>{factoryExpanded?.country}</td>
                          <td>{factoryExpanded?.zipCode}</td>
                          <td>{factoryExpanded?.portOfLanding}</td>
                          <td>{factoryExpandedInfoData?.moq}</td>
                          <td>{factoryExpandedInfoData?.minimumColourQuantiy}</td>
                          <td>{factoryExpanded?.energySource?.label}</td>
                          <td>{factoryExpanded?.energyIntensity}</td>
                          <td>{factoryExpanded?.noOfWorkers}</td>
                          <td>{factoryExpanded?.internalPointContact?.label || factoryExpanded?.internalPointContact}</td>
                          <td>{shortenandHoverString(factoryExpanded?.factorynote, 40)}</td>
                          <td>{factoryExpanded?.newLeadTime}</td>
                          <td>{factoryExpanded?.tags?.join(', ')}</td>
                          <td>
                            {factoryExpanded?.contactPersons?.map((item) => {
                              return (
                                <p className="mb-1" key={item?._id}>
                                  {item?.name}
                                </p>
                              );
                            })}
                          </td>
                          <td>
                            {factoryExpanded?.contactPersons?.map((item) => {
                              return (
                                <p className="mb-1" key={item?._id}>
                                  {item?.jobTitle}
                                </p>
                              );
                            })}
                          </td>
                          <td>
                            {factoryExpanded?.contactPersons?.map((item) => {
                              return (
                                <p className="mb-1" key={item?._id}>
                                  {item?.email}
                                </p>
                              );
                            })}
                          </td>
                          <td>
                            {factoryExpanded?.contactPersons?.map((item) => {
                              return (
                                <p className="mb-1" key={item?._id}>
                                  {item?.phoneNo}
                                </p>
                              );
                            })}
                          </td>
                          <td>{noOfDocsExpad}</td>
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan="100%" className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}
